import React from 'react';
import { Link } from 'react-router-dom';
import './PortalHeader.css';

function PortalHeader({ children }) {
    return (
        <header className="portal-header">
            <Link to="/dashboard" className="portal-header-brand" aria-label="Return to dashboard">
                <img src={require('./abadata_logo_light.png')} alt="AbaData" />
            </Link>
            {children ? <div className="portal-header-actions">{children}</div> : null}
        </header>
    );
}

export default PortalHeader;
